// src/views/EditDossier.vue
<template>
  <div class="edit-dossier-view">
    <div v-if="loading" class="loading">Chargement du dossier...</div>
    <div v-else-if="error" class="error-message">{{ error }}</div>
    <div v-else-if="!dossierToEdit" class="error-message">Dossier non trouvé ou accès refusé.</div>
    <DossierForm
        v-else
        :key="dossierToEdit.id" 
        
        :editing-dossier="dossierToEdit"
        @dossier-updated="handleDossierUpdated"
        @cancel-edit="goBackToList"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { supabase } from '../../supabase.js';
import DossierForm from '@/components/DossierForm.vue';

const route = useRoute();
const router = useRouter();

const dossierToEdit = ref(null);
const loading = ref(false);
const error = ref('');

const fetchDossier = async (id) => {
    if (!id) {
        error.value = "Aucun ID de dossier fourni.";
        return;
    }
    loading.value = true;
    error.value = '';
    console.log(`Fetching dossier with ID: ${id} for editing.`);

    try {
        // You can fetch directly here if RLS allows reading own dossier
        // Or ideally, use an Edge Function if you need more checks/logic
        // For simplicity, let's try direct fetch first (relies on RLS)

        const { data: { user } } = await supabase.auth.getUser();
         if (!user) throw new Error("Authentification requise.");

        const { data, error: dbError } = await supabase
            .from('dossiers')
            .select('*') // Select all columns including raw_data
            .eq('id', id)
            .eq('user_id', user.id) // Ensure ownership (redundant if RLS is perfect, but safe)
            .single(); // Expect only one

        if (dbError) {
             if (dbError.code === 'PGRST116') { // Not found or RLS denied
                 throw new Error("Dossier non trouvé ou accès refusé.");
             }
             throw dbError; // Throw other DB errors
        }

        if (!data) {
            throw new Error("Dossier non trouvé.");
        }

        dossierToEdit.value = data;
        console.log("Dossier loaded for editing:", data);

    } catch (err) {
        console.error("Error fetching dossier for edit:", err);
        error.value = `Impossible de charger le dossier : ${err.message}`;
        dossierToEdit.value = null; // Clear data on error
    } finally {
        loading.value = false;
    }
};

const handleDossierUpdated = () => {
    alert('Dossier mis à jour avec succès !');
    // Go back to the list view after successful update
    router.push({ name: 'home' }); // Assuming 'home' is your list view route name
};

const goBackToList = () => {
    router.push({ name: 'home' });
};

// Fetch the dossier when the component mounts based on the route param
onMounted(() => {
    const dossierId = route.params.id; // Get ID from the URL
    fetchDossier(dossierId);
});

</script>

